// extracted by mini-css-extract-plugin
module.exports = {"textHeroWrapper":"text-hero-module--text-hero-wrapper--2OAIJ"};